import { Box, IconButton, Typography } from "@mui/material";
import { BORDER } from "./constants";

const PaginationFooter = ({
  totalRows,
  startIdx,
  endIdx,
  safePage,
  totalPages,
  pageNumbers,
  onPageChange,
  showBorder,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2.5,
      py: 1.25,
      borderTop: showBorder ? BORDER : "none",
      flexShrink: 0,
    }}
  >
    <Typography variant="caption" color="text.secondary">
      {totalRows > 0
        ? `${startIdx + 1}–${endIdx} sur ${totalRows} résultat${totalRows !== 1 ? "s" : ""}`
        : "0 résultat"}
    </Typography>

    <Box display="flex" alignItems="center" gap={0.5}>
      {" "}
      <IconButton
        size="small"
        onClick={() => onPageChange(safePage - 1)}
        disabled={safePage === 0}
        sx={{
          width: 28,
          height: 28,
          borderRadius: "8px",
          border: BORDER,
          "&.Mui-disabled": { opacity: 0.35 },
        }}
      >
        <Typography sx={{ fontSize: 14, lineHeight: 1 }}>‹</Typography>
      </IconButton>
      {pageNumbers.map((num, i) => {
        const prev = pageNumbers[i - 1];
        const showEllipsis = prev !== undefined && num - prev > 1;
        return (
          <Box key={num} display="inline-flex" alignItems="center" gap={0.5}>
            {showEllipsis && (
              <Typography
                sx={{
                  fontSize: 12,
                  color: "text.secondary",
                  px: 0.25,
                }}
              >
                …
              </Typography>
            )}
            <IconButton
              size="small"
              onClick={() => onPageChange(num)}
              sx={{
                width: 28,
                height: 28,
                borderRadius: "8px",
                border:
                  num === safePage ? "1px solid rgba(0,0,0,0.35)" : BORDER,
                backgroundColor:
                  num === safePage ? "rgba(0,0,0,0.06)" : "transparent",
              }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: num === safePage ? 500 : 400,
                }}
              >
                {num + 1}
              </Typography>
            </IconButton>
          </Box>
        );
      })}
      <IconButton
        size="small"
        onClick={() => onPageChange(safePage + 1)}
        disabled={safePage >= totalPages - 1}
        sx={{
          width: 28,
          height: 28,
          borderRadius: "8px",
          border: BORDER,
          "&.Mui-disabled": { opacity: 0.35 },
        }}
      >
        <Typography sx={{ fontSize: 14, lineHeight: 1 }}>›</Typography>
      </IconButton>
    </Box>
  </Box>
);

export default PaginationFooter;
